var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',[_c('el-row',[_c('el-col',{attrs:{"span":3}},[_vm._v(" ")]),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('el-link',{attrs:{"underline":false,"href":"http://beian.miit.gov.cn","target":"_blank"}},[_vm._v("京ICP备16009388号-3")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_vm._v(" ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12c741e1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = JuRn
// module chunks = 1